import React from 'react';

import { CLIVE_VIBERANT_BORDER } from '~/components/Clive/cliveRegistry';

import type { ButtonProps } from '../../core/Atomic/Buttons/Button';
import Button from '../../core/Atomic/Buttons/Button';

export interface CliveButtonProps extends Pick<ButtonProps, 'onClick' | 'disabled'> {
  text: string;
}

const CliveButton: React.FC<CliveButtonProps> = ({ text, onClick, disabled = false }) => {
  const className = `transition-colors duration-200 normal-case rounded-full px-16 py-2 break-words whitespace-normal overflow-hidden text-center min-w-max ${CLIVE_VIBERANT_BORDER} text-blue-900 disabled:text-grey-300 disabled:border-grey-200 disabled:[background:#fff]`;

  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      className={className}
      disableRipple={true}
      disableElevation={true}
      size="medium"
      type="button"
    >
      {text}
    </Button>
  );
};

export default CliveButton;
